import axios, { AxiosResponse } from 'axios';
import { StepData } from '../service/store/step-engine-state';
import asyncHandler from '../../../shared/util/asyncHandler';
export interface IStepEngineApi {
  nextStep(step: StepData): Promise<AxiosResponse<any>>;
  specificStep(step: StepData): Promise<AxiosResponse<any>>;
}

class StepEngineApi implements IStepEngineApi {
  async nextStep(stepData: StepData): Promise<AxiosResponse<any>> {
    return asyncHandler(axios.post('/stepEngine/nextStep', stepData))
  }
  async specificStep(stepData: any): Promise<AxiosResponse<any>> {
    return asyncHandler(axios.post('/stepEngine/specificStep', stepData))
  }
}

const stepEngineApi = new StepEngineApi();

export { stepEngineApi };
